import IUser from '../../models/user';
import secureLocalStorage from 'react-secure-storage';
import { ELanguage } from '../../models/enums/language';

class Auth {
    setLanguage(language: ELanguage) {
        const oldUser: IUser | undefined = this.user;
        if (!oldUser) return;
        this.setAuth({ ...oldUser, language });
    }
    get user() {
        const cashedUser = secureLocalStorage.getItem('user');
        let user: IUser | undefined;
        if (cashedUser) user = JSON.parse(cashedUser?.toString());
        return user;
    }

    get guid() {
        return this.user?.guid || '';
    }

    get email() {
        return this.user?.email || '';
    }

    setAuth(user: IUser | undefined) {
        user ? secureLocalStorage.setItem('user', JSON.stringify(user)) : secureLocalStorage.clear();
    }

    disconnect(): void {
        this.setAuth(undefined);
    }
}

const auth = new Auth();

export default auth;
